export default __webpack_public_path__ + "images/QS.344bb63.png";